import styled, { css } from 'styled-components';
import { Select } from '../../inputs/select/select';

export const inlineFormSelectStyles = css`
  .lgg-select__control {
    min-height: 32px;
    padding: 4px 6px;
    border-radius: 4px;
    border-color: transparent;
    color: rgb(87, 114, 138);

    &:hover {
      background: ${({ theme }) => theme.colors.alabaster};
      border-color: ${({ theme }) => theme.colors.alabaster};
    }

    &:active,
    &:focus {
      ${({ theme }) => theme.inputsTheme.focusBorder};
    }
  }
`;

export const InlineFormSelect = styled(Select)`
  ${inlineFormSelectStyles};
` as typeof Select;
